<template>
  <v-container>
    <toolbar mode="export" title="Generate" view="list" />
    <v-card flat>
      <v-tabs v-model="tab">
        <v-tab href="#default">Default</v-tab>
        <v-tab href="#combocurve">ComboCurve</v-tab>
        <v-tab href="#aries">ARIES</v-tab>
      </v-tabs>
      <v-divider></v-divider>
      <v-tabs-items v-model="tab">
        <v-tab-item value="default">
          <ExportForm v-if="tab == 'default'"
                      :predictions="predictions"
                      :connections="connections"
                      :techniques="techniques"
                      @submitted="onSubmit">
          </ExportForm>
        </v-tab-item>
        <v-tab-item value="combocurve">
          <ExportComboCurveForm v-if="tab == 'combocurve'"
                                 :predictions="predictions"
                                 :techniques="techniques"
                                 @submitted="onSubmit">
          </ExportComboCurveForm>
        </v-tab-item>
        <v-tab-item value="aries">
          <ExportAriesForm v-if="tab == 'aries'"
                            :predictions="predictions"
                            :techniques="techniques"
                            @submitted="onSubmit">
          </ExportAriesForm>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
<script>
import ExportForm from "@/components/Forms/Export"
import ExportComboCurveForm from "@/components/Forms/ExportComboCurve"
import ExportAriesForm from "@/components/Forms/ExportAries"
import Exports from "@/api/exports"
import Connections from "@/api/connections"
import Predictions from "@/api/predictions"
import Techniques from "@/api/techniques"
import toolbar from "@/components/toolbar"
export default {
  name: "ExportCreate",
  components: {
    toolbar,
    ExportForm,
    ExportComboCurveForm,
    ExportAriesForm,
  },
  data() {
    return {
      tab: 'default',
      predictions: [],
      techniques: [],
      connections: [],
    }
  },
  mounted() {
    Predictions.list().then(response => this.predictions = response.data.results)
    Connections.list().then(response => this.connections = response.data)
    Techniques.list().then(response => this.techniques = response.data )
  },
  methods: {
    onSubmit(data) {
      let payload = {
        prediction: data.prediction,
        config: data.config,
        owner: this.user.id
      }
      Exports.create(payload).then(_ => {
        this.notify('Generating export')
        this.$router.push({ name: 'exportList' })
      })
    }
  }
}
</script>
